__turbopack_context__.v({
  "file-input": "AvVEnq_file-input",
  "file-input-label": "AvVEnq_file-input-label",
  "file-input-label--icon": "AvVEnq_file-input-label--icon",
  "file-input-label--icon--selected": "AvVEnq_file-input-label--icon--selected",
  "file-input-label--inverted": "AvVEnq_file-input-label--inverted",
  "file-input-label--plain": "AvVEnq_file-input-label--plain",
  "file-input-label--secondary": "AvVEnq_file-input-label--secondary",
  "file-input-label--small": "AvVEnq_file-input-label--small",
  "file-input-label--tertiary": "AvVEnq_file-input-label--tertiary",
  "file-input-label-chip": "AvVEnq_file-input-label-chip",
  "file-input-label-chip--interactive": "AvVEnq_file-input-label-chip--interactive",
  "file-input-label-chip--is-rounded": "AvVEnq_file-input-label-chip--is-rounded",
  "file-input-label-chip--not-clickable": "AvVEnq_file-input-label-chip--not-clickable",
  "file-input-label-chip--small": "AvVEnq_file-input-label-chip--small",
  "file-input-label-chip--theme-active": "AvVEnq_file-input-label-chip--theme-active",
  "file-input-label-chip--theme-emphasis": "AvVEnq_file-input-label-chip--theme-emphasis",
  "file-input-label-chip--theme-light": "AvVEnq_file-input-label-chip--theme-light",
  "file-input-label-chip__icon-container": "AvVEnq_file-input-label-chip__icon-container",
  "file-input-label__prefix": "AvVEnq_file-input-label__prefix",
  "file-input-label__suffix": "AvVEnq_file-input-label__suffix",
});
